import { ActionContext } from 'vuex';
import { Statistics } from 'src/api';
import { StateInterface } from 'src/store';
import { StatisticsStateInterface } from 'src/store/statistics/state';
import StatDataSet = Statistics.Types.StatDataSet;
import StatPointList = Statistics.Types.StatPointList;
import StatCountValue = Statistics.Types.StatCountValue;
import StatIncrementValue = Statistics.Types.StatIncrementValue;
import PendingPostings = Statistics.Types.PendingPostings;

export function resetData(
  context: ActionContext<StatisticsStateInterface, StateInterface>
) {
  return Promise.all([
    context.dispatch('setValidateData', { validationFailures: [] }),
    context.dispatch('setInProcessData', { inProcessPostings: [] }),
    context.dispatch('setDeliverData', {
      deliveredPostings: [],
      deliveredNewPostings: [],
      deliveryFailures: { count: 0 },
    }),
  ]);
}

export function setValidateData(
  context: ActionContext<StatisticsStateInterface, StateInterface>,
  payload: StatDataSet // todo: update interface?
) {
  void context.commit('SET_VALIDATION_FAILURES', payload.validationFailures);
  // void context.commit('SET_VALIDATION_SUCCESS', payload.validationSuccess); // disabled on API side
  void context.commit('SET_VALIDATION_LOADING', false);
}

export function setInProcessData(
  context: ActionContext<StatisticsStateInterface, StateInterface>,
  payload: StatDataSet // todo: update interface?
) {
  void context.commit('SET_IN_PROCESS_POSTINGS', payload.inProcessPostings);
  void context.commit('SET_IN_PROCESS_LOADING', false);
}

export function setDeliverData(
  context: ActionContext<StatisticsStateInterface, StateInterface>,
  payload: StatDataSet // todo: update interface?
) {
  void context.commit('SET_DELIVERED_POSTINGS', payload.deliveredPostings);
  void context.commit(
    'SET_DELIVERED_NEW_POSTINGS',
    payload.deliveredNewPostings
  );
  void context.commit('SET_DELIVERY_FAILURES', payload.deliveryFailures);
  void context.commit('SET_DELIVERY_LOADING', false);
}

export function setValidationFailures(
  context: ActionContext<StatisticsStateInterface, StateInterface>,
  payload: StatPointList
) {
  return context.commit('SET_VALIDATION_FAILURES', payload);
}
export function addValidationFailures(
  context: ActionContext<StatisticsStateInterface, StateInterface>,
  payload: StatIncrementValue
) {
  return context.commit('ADD_VALIDATION_FAILURES', payload);
}

export function setDeliveredPostings(
  context: ActionContext<StatisticsStateInterface, StateInterface>,
  payload: StatPointList
) {
  return context.commit('SET_DELIVERED_POSTINGS', payload);
}
export function addDeliveredPostings(
  context: ActionContext<StatisticsStateInterface, StateInterface>,
  payload: StatIncrementValue
) {
  return context.commit('ADD_DELIVERED_POSTINGS', payload);
}

export function setDeliveredNewPostings(
  context: ActionContext<StatisticsStateInterface, StateInterface>,
  payload: StatPointList
) {
  return context.commit('SET_DELIVERED_NEW_POSTINGS', payload);
}
export function addDeliveredNewPostings(
  context: ActionContext<StatisticsStateInterface, StateInterface>,
  payload: StatIncrementValue
) {
  return context.commit('ADD_DELIVERED_NEW_POSTINGS', payload);
}

export function setDeliveryFailures(
  context: ActionContext<StatisticsStateInterface, StateInterface>,
  payload: StatCountValue
) {
  return context.commit('SET_DELIVERY_FAILURES', payload);
}
export function addDeliveryFailures(
  context: ActionContext<StatisticsStateInterface, StateInterface>,
  payload: StatIncrementValue
) {
  return context.commit('ADD_DELIVERY_FAILURES', payload);
}

export function setDeliverySuccess(
  context: ActionContext<StatisticsStateInterface, StateInterface>,
  payload: StatCountValue
) {
  return context.commit('SET_DELIVERY_SUCCESS', payload);
}
export function addDeliverySuccess(
  context: ActionContext<StatisticsStateInterface, StateInterface>,
  payload: StatIncrementValue
) {
  return context.commit('ADD_DELIVERY_SUCCESS', payload);
}

export function setInProcessPostings(
  context: ActionContext<StatisticsStateInterface, StateInterface>,
  payload: StatPointList
) {
  return context.commit('SET_IN_PROCESS_POSTINGS', payload);
}
export function addInProcessPostings(
  context: ActionContext<StatisticsStateInterface, StateInterface>,
  payload: StatIncrementValue
) {
  return context.commit('ADD_IN_PROCESS_POSTINGS', payload);
}

export function setPendingPostingsUrl(
  context: ActionContext<StatisticsStateInterface, StateInterface>,
  payload: PendingPostings
) {
  return context.commit('SET_PENDING_POSTINGS', payload);
}

export function setPeriod(
  context: ActionContext<StatisticsStateInterface, StateInterface>,
  payload: string
) {
  return context.commit('SET_PERIOD', payload);
}

export function setLoading(
  context: ActionContext<StatisticsStateInterface, StateInterface>,
  loading: boolean
) {
  return Promise.all([
    context.commit('SET_DELIVERY_LOADING', loading),
    context.commit('SET_VALIDATION_LOADING', loading),
    context.commit('SET_IN_PROCESS_LOADING', loading),
  ]);
}
